import type AttachmentViewState from '../schema/AttachmentViewState';
import type ImageLoadState from '../schema/ImageLoadState';
import { mutatorAction } from 'satcheljs';

const setThumbnailLoadStateMutator: (
    attachment: AttachmentViewState,
    newState: ImageLoadState
) => void = mutatorAction(
    'setThumbnailLoadState',
    function setThumbnailLoadState(
        attachment: AttachmentViewState,
        newState: ImageLoadState
    ): void {
        attachment.thumbnailLoadState = newState;
    }
);
export default setThumbnailLoadStateMutator;
